import { render, staticRenderFns } from "./StudentPeriod.vue?vue&type=template&id=38301622&scoped=true&"
import script from "./StudentPeriod.vue?vue&type=script&lang=js&"
export * from "./StudentPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38301622",
  null
  
)

export default component.exports